import { SearchOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import SuggestedQuestion from "../create/SuggestedQuestion";
import DonePlaylist from "./DonePlaylist";
import Playlistnamesettings from "./Playlistnamesettings";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import PlaylistQuestion from "./PlaylistQuestion";
import HomeSearch from "../Search/HomeSearch";
import AddFloatingButton from "./AddFloatingButton";
import FlagLocalhost from "../../Localhost/FlagLocalhost";
import { PageDataInterface } from "../../utlis/Interface/homeSearch";
/**
 * CreatePlaylist Component
 * -----------------------
 * This component provides the main UI and logic for
 * creating or editing a playlist.
 *
 * Responsibilities:
 * 1. Manage playlist creation & edit modes
 * 2. Handle search, pagination, and suggested questions
 * 3. Prevent accidental refresh during edit mode
 * 4. Coordinate child components for playlist configuration
 * 5. Support Evidya-specific entry flows
 */
const CreatePlaylist = () => {
	/**
	 * Controls whether page refresh warning should be shown
	 * (used primarily in playlist edit mode)
	 */
	const [refresh, setRefresh] = useState<boolean>(true);

	/**
	 * Pagination state for search and suggested questions
	 */
	const [pageData, setPageData] = useState<PageDataInterface>({
		page: 1,
		pageSize: 10,
	});

	/**
	 * Controls UI blur effect when modal-like components are active
	 */
	const [isBlurred, setIsBlurred] = useState<string>("");

	/**
	 * Stores active search tags selected from HomeSearch
	 */
	const [searchTags, setSearchTags] = useState<any>([]);

	const dispatch = useDispatch();

	/**
	 * Playlist state from Redux
	 * Includes mode (create/edit), selected questions, etc.
	 */
	const playlist: any = useSelector((state: RootState) => state.playlist);
	if (playlist.mode === 1) {
		// dispatch(playlisteditmode(playlist.playlist_to_edit))
	}
	/**
	 * Detects whether user arrived from Evidya platform
	 */
	const flag = FlagLocalhost();

	/**
	 * Warns user before refreshing or closing the page
	 * to prevent accidental loss of changes
	 */
	const handleBeforeUnload = (event) => {
		if (refresh) {
			const message =
				"Are you sure you want to refresh? Your changes will be lost.";
			event.returnValue = message;
			setRefresh(false);
			return message;
		}
	};
	/**
	 * Handles pagination changes from SuggestedQuestion component
	 */
	const handlePageChange = (page, pageSize) => {
		setPageData({ page: page, pageSize: pageSize });
	};

	/**
	 * Attach refresh warning only when:
	 * - Playlist is in edit mode
	 * - Refresh protection is enabled
	 */
	useEffect(() => {
		if (refresh && playlist.mode === 1) {
			window.addEventListener("beforeunload", handleBeforeUnload);
			setRefresh(true);
			return () => {
				window.removeEventListener("beforeunload", handleBeforeUnload);
			};
		}
	}, [refresh]);
	/**
	 * Reset blur state on initial mount
	 */
	useEffect(() => {
		setIsBlurred("");
	}, []);

	return (
		<div style={{ filter: isBlurred }}>
			<Row gutter={[24, 6]}>
				<Col xl={12} xs={24} md={12}>
					<div className="playlist-div">
						{/* Playlist name & settings */}
						<Playlistnamesettings />

						{/* Playlist questions based on mode */}
						{playlist.mode === 0 &&
						playlist.question_ids.length !== 0 ? (
							<PlaylistQuestion
								isBlurred={isBlurred}
								setIsBlurred={setIsBlurred}
							/>
						) : playlist.mode === 1 &&
						  playlist.playlist_to_edit.question_ids.length !==
								0 ? (
							<PlaylistQuestion
								isBlurred={isBlurred}
								setIsBlurred={setIsBlurred}
							/>
						) : (
							""
						)}
					</div>
				</Col>

				{/* Right Panel: Search & Suggested Questions */}
				<Col xl={12} xs={24} md={12}>
					<div>
						<Card
							bordered={true}
							className="playlist-settings-saggestedcard"
						>
							<Row gutter={[24, 6]}>
								{/* <Input
									allowClear
									style={{ borderRadius: "20px" }}
									placeholder=" Type something..."
									size="middle"
									suffix={suffix}
									onChange={handleChange}
								/> */}
								<Col xl={24} md={24} xs={24}>
									<HomeSearch
										searchMode={0}
										setShowQuestion={() => {}}
										searchTags={searchTags}
										setSearchTags={setSearchTags}
										pageData={pageData}
										playlistPageData={pageData}
									/>
								</Col>
							</Row>
							<Row
								gutter={[24, 6]}
								className="playlist-search-card"
							>
								<Col xl={24} xs={24} md={24}>
									<SuggestedQuestion
										handlePageChange={handlePageChange}
										pageData={pageData}
									/>
								</Col>
							</Row>
						</Card>
					</div>
				</Col>
			</Row>
			{/* Footer: Done Playlist Action */}
			<Row gutter={[24, 6]} className="playlist-ok">
				{playlist.question_ids.length !== 0 && (
					<DonePlaylist
						isBlurred={isBlurred}
						setIsBlurred={setIsBlurred}
					/>
				)}
				{playlist.mode === 1 && playlist.question_ids.length === 0 && (
					<DonePlaylist
						isBlurred={isBlurred}
						setIsBlurred={setIsBlurred}
					/>
				)}
			</Row>
			{/* Evidya-specific floating action button */}
			<Row
				gutter={[24, 6]}
				style={{ position: "fixed", bottom: "4vh", right: "4vw" }}
			>
				{flag?.isFromEvidya === 1 && <AddFloatingButton />}
			</Row>
		</div>
	);
};

export default CreatePlaylist;
